import { ButtonMenuBigComponent } from './button-menu-big.component';

export const ButtonMenuBigModule = angular
  .module('sfMobile.components.button-menu-big', [])
  .component('sfButtonMenuBig', ButtonMenuBigComponent).name;
